var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 131,
    viewBox: "0 0 152 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4521 104.188L17.916 101.652L38.2084 81.3594L40.7446 83.8956L20.4521 104.188Z",
    fill: "#A3B5D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1491 85.8189C46.5208 85.8189 36.2838 75.5818 36.2838 62.9537C36.2838 50.3256 46.5208 40.0885 59.1491 40.0885C71.777 40.0885 82.0143 50.3256 82.0143 62.9537C82.0143 75.5818 71.777 85.8189 59.1491 85.8189ZM59.1491 32.4668C42.3115 32.4668 28.6621 46.1162 28.6621 62.9537C28.6621 79.7912 42.3115 93.4407 59.1491 93.4407C75.9865 93.4407 89.636 79.7912 89.636 62.9537C89.636 46.1162 75.9865 32.4668 59.1491 32.4668Z",
    fill: "#6992EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9863 62.9548C42.9863 54.0279 50.2232 46.791 59.1502 46.791C68.0772 46.791 75.314 54.0279 75.314 62.9548C75.314 71.8819 68.0772 79.1187 59.1502 79.1187C50.2232 79.1187 42.9863 71.8819 42.9863 62.9548Z",
    fill: "#CBD5E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1503 71.9218C54.198 71.9218 50.1836 67.9073 50.1836 62.955C50.1836 58.0028 54.198 53.9883 59.1503 53.9883C64.1026 53.9883 68.1171 58.0028 68.1171 62.955C68.1171 67.9073 64.1026 71.9218 59.1503 71.9218Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6238 114.017L8.08773 111.481C7.38742 110.781 7.38742 109.645 8.08774 108.945L25.9055 91.1268C26.6059 90.4265 27.7414 90.4265 28.4417 91.1268C28.4417 91.1268 28.4417 91.1268 28.4417 91.1268L30.9779 93.663C31.6782 94.3634 31.6782 95.4989 30.9779 96.1992L13.16 114.017C12.4597 114.717 11.3242 114.717 10.6238 114.017C10.6238 114.017 10.6238 114.017 10.6238 114.017Z",
    fill: "#3B82F6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4542 56.6953H22.1309C21.4319 56.6953 20.8652 57.262 20.8652 57.9609L20.8652 61.2843C20.8652 61.9833 21.4319 62.5499 22.1309 62.5499H25.4542C26.1532 62.5499 26.7198 61.9833 26.7198 61.2843V57.9609C26.7198 57.262 26.1532 56.6953 25.4542 56.6953Z",
    fill: "#3B82F6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1081 25.5586H70.8633C70.1643 25.5586 69.5977 26.1252 69.5977 26.8242L69.5977 29.0691C69.5977 29.7681 70.1643 30.3347 70.8633 30.3347H73.1081C73.8071 30.3347 74.3738 29.7681 74.3738 29.0691V26.8242C74.3738 26.1252 73.8071 25.5586 73.1081 25.5586Z",
    fill: "#65A30D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.052 39.6968L95.3306 34.9752C95.1923 34.8368 94.9679 34.8368 94.8295 34.9752L90.1079 39.6968C89.9695 39.8352 89.9695 40.0596 90.1079 40.1979L94.8295 44.9196C94.9679 45.058 95.1923 45.058 95.3306 44.9196L100.052 40.1979C100.191 40.0596 100.191 39.8352 100.052 39.6968Z",
    fill: "#DEE5FD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M140.776 72.4751L137.177 68.8765C137.072 68.771 136.901 68.771 136.795 68.8765L133.197 72.4751C133.091 72.5806 133.091 72.7516 133.197 72.857L136.795 76.4556C136.901 76.5611 137.072 76.5611 137.177 76.4556L140.776 72.857C140.881 72.7516 140.881 72.5806 140.776 72.4751Z",
    fill: "#DC2626"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8906 92.9961H130.2V113.305C130.2 114.182 129.489 114.893 128.612 114.893H89.4783C88.6014 114.893 87.8906 114.182 87.8906 113.305V92.9961Z",
    fill: "url(#paint0_linear_1293_16053)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7812 85.2988L83.6526 94.3816C83.4957 94.7094 83.5179 95.0947 83.7113 95.4023C83.9048 95.7099 84.2425 95.8967 84.6059 95.8972H133.328C133.7 95.8972 134.044 95.7024 134.235 95.3842C134.426 95.0659 134.437 94.6706 134.263 94.3426L130.22 85.2988H87.7812Z",
    fill: "#E4EBF7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M121.671 78.9961L130.219 85.2998H87.7773L96.28 78.9961H121.671Z",
    fill: "#ADC6FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.28 78.9961V85.2998H87.7773L96.28 78.9961Z",
    fill: "#3B82F6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M121.672 78.9961V85.2952L130.22 85.2998L121.672 78.9961Z",
    fill: "#3B82F6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.416 56.263C114.695 54.8484 115.258 53.1172 116.672 52.3964C118.087 51.6756 119.818 52.2381 120.539 53.6527C121.26 55.0674 120.697 56.7985 119.283 57.5194C117.868 58.2402 116.137 57.6777 115.416 56.263ZM120.736 63.2357L123.053 62.0549L122.587 59.992C123.003 59.611 123.366 59.1839 123.67 58.7227L125.781 58.8608L126.585 56.3872L124.796 55.2581C124.821 54.7061 124.779 54.1475 124.665 53.5943L126.255 52.1996L125.075 49.8822L123.012 50.3487C122.631 49.9321 122.204 49.5696 121.742 49.2652L121.88 47.1542L119.407 46.3505L118.278 48.1395C117.726 48.1147 117.167 48.1569 116.614 48.27L115.219 46.6801L112.902 47.8608L113.368 49.9237C112.952 50.3047 112.589 50.7319 112.285 51.193L110.174 51.055L109.37 53.5285L111.159 54.6576C111.134 55.2096 111.177 55.7682 111.29 56.3214L109.7 57.7161L110.881 60.0335L112.943 59.567C113.324 59.9836 113.752 60.3461 114.213 60.6505L114.075 62.7615L116.548 63.5652L117.677 61.7762C118.229 61.801 118.788 61.7589 119.341 61.6457L120.736 63.2357Z",
    fill: "#FB923C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1071 18.9393C27.8128 13.5982 29.4002 10.2728 30.8667 8.96176C34.9278 5.33311 40.5429 7.30797 41.7367 7.59082C45.9303 8.58717 44.5667 2.03063 48.1648 0.697919C50.5626 -0.190131 52.5346 0.895405 54.0821 3.95453C55.4521 1.10054 57.54 -0.206695 60.3456 0.0264665C64.5546 0.379393 66.0275 14.4595 71.8111 11.3775C77.596 8.29413 84.6879 7.58955 87.7173 12.1712C88.3721 13.1625 88.6229 11.6246 93.0764 6.37405C97.5299 1.1222 101.97 -1.19158 111.081 1.86627C115.223 3.25505 118.629 7.02002 121.304 13.1599C121.304 21.9232 127.813 27.1114 140.828 28.7206C160.354 31.135 145.198 51.9271 121.304 58.016C97.4077 64.1063 42.3927 67.3934 12.5383 52.0074C-7.36473 41.7521 -2.84179 30.7285 26.1058 18.9393H26.1071Z",
    fill: "url(#paint1_linear_1293_16053)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.675,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.808 128.759C106.125 133.994 21.8762 128.007 12.909 125.273C8.54445 123.941 4.61039 121.437 1.10798 117.76C0.715979 117.349 0.469583 116.852 0.397263 116.328C0.324942 115.803 0.429649 115.272 0.699284 114.796C0.968919 114.319 1.39247 113.917 1.92101 113.636C2.44954 113.354 3.06148 113.205 3.68611 113.205H150.907C153.963 120.085 147.263 125.27 130.808 128.759Z",
    fill: "url(#paint2_linear_1293_16053)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1293_16053",
    x1: 109.045,
    y1: 92.9961,
    x2: 108.941,
    y2: 122.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#497BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFC8FA",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1293_16053",
    x1: 78.5799,
    y1: 47.0782,
    x2: 78.5799,
    y2: -11.1274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEDE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9A9",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1293_16053",
    x1: 76,
    y1: 130.835,
    x2: 76,
    y2: 109.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919191",
    stopOpacity: 0.15
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.d14a7f4a085abf995ba0c438dba5eb24.svg";
export { ForwardRef as ReactComponent };